import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GameRecord } from 'diwimamodelweb/lib';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GamerecordService } from 'src/app/shared/gamerecord.service';
import { SettingsService } from 'src/app/shared/settings.service';
import { UserFeedbackService } from 'src/app/shared/user-feedback.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GamerecordStatisticsService {

  myData:any
  ngUnsubscribe: Subject<void> = new Subject<void>();

  queryMap = new Map<string, {records: GameRecord[], selected: boolean}>()
  allGameRecords$ = new BehaviorSubject<GameRecord[]|undefined>(undefined)
  optionsGroups = ['ownDistrict', 'reportingDistrict']

  constructor(
    private gamerecordService: GamerecordService,
    private settingsService: SettingsService,
    private http: HttpClient,
    private translateService: TranslateService,
    private userFeedbackService: UserFeedbackService
  ) {
    const n = this.translateService.instant('my_data')
    this.myData = {
      identifier: "IST_EH_EGAL",
      huntingDistrictName: n
    }

    this.gamerecordService.allGameRecordsSubject$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((gameRecords: GameRecord[]) => {
      const selectedContext = this.settingsService.selectedUserContext$.value
      if (!selectedContext) return 
      const d = this.queryMap.get(selectedContext.identifier)
      if (d) {
        this.queryMap.set(selectedContext.identifier, Object.assign(d, {records: gameRecords}))
      } else {
        this.queryMap.set(selectedContext.identifier, {selected: true, records: gameRecords})
      }
      this.updateAllGameRecords()
    })
    this.settingsService.selectedUserContext$.subscribe((sel) => {
      if (!sel) {
        // reset values
        this.queryMap = new Map()
      }
    })
  }

  private resetData() {
    this.queryMap = new Map()
    this.allGameRecords$.next(undefined)
  }

  async removeSubs() {
    this.ngUnsubscribe.next()
    this.resetData()
    return Promise.resolve()
  }

  getRecordsOfReportingContext(reportingId: string, selected: boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.queryMap.get(reportingId)) {
        const url = `${environment.apiURL}/gamerecord/${reportingId}`

        this.http.get(url)
          .subscribe({
            next: (elements: any[]) => {
              let listGR: GameRecord[] = []
              elements.forEach((el) => {
                const gr = new GameRecord()
                gr.setFromAny(el)
                listGR.push(gr)
              })
              this.queryMap.set(reportingId, {records: listGR, selected})
              this.updateAllGameRecords()
              resolve()
            },
            error: (error) => {
              console.error(error)
              reject(error)
            }
          })
      } else {
        this.queryMap.set(reportingId, Object.assign(this.queryMap.get(reportingId), {selected}))
        this.updateAllGameRecords()
        resolve()
      }
    })
  }

  setShowMyData(bol: boolean) {
    const selectedContext = this.settingsService.selectedUserContext$.value
    if (bol != this.queryMap.get(selectedContext.identifier)?.selected) {
      // this.queryMap.set(selectedContext.identifier, Object.assign(this.queryMap.get(selectedContext.identifier) , {selected: bol})) // add ?? to prevent error on assign
      this.queryMap.set(selectedContext.identifier, Object.assign(this.queryMap.get(selectedContext.identifier) ?? {records: this.gamerecordService.allGameRecordsSubject$.value, selected: false} , {selected: bol}))
      this.updateAllGameRecords()
    }
  }

  setShowReportingId(id, bol) {
    if (this.queryMap.get(id)) {
      if (bol != this.queryMap.get(id)?.selected) {
        this.queryMap.set(id, Object.assign(this.queryMap.get(id), {selected: bol}))
        this.updateAllGameRecords()
      }
    }
  }

  private updateAllGameRecords() {
    this.userFeedbackService.loading.emit(true)
    let all: GameRecord[] = []
    this.queryMap.forEach((value, key) => {
      if (value && value.selected && value.records) {
        all = [...all, ...value.records]
      }
    })
    this.allGameRecords$.next(all)
    this.userFeedbackService.loading.emit(false)
  }
}
